module.exports = __webpack_public_path__ + "a825ce65f98c79f23117ca978237c6cd.fbx";